import React, { useEffect, useState } from 'react';
import { getCallHistoryDetails } from '../../api/history-control';
import { CallHistoryDetailsEntry, MediaType, TaskItemAction } from '../../model';
import Button from '../Button';
import './CallDetailsPanel.scss';
import Modal from '../Modal';

export interface ShowCallState {
  itemId: string
  itemType: MediaType
}

export default function CallViewPanelByItem({ state, onClose }: { state: ShowCallState, onClose(): void }) {
  const customStyles = {
    content: {
      width: '400px',
      height: '200px',
    },
  };

  return <Modal style={customStyles} isOpen={true}>
    <CallViewByItemDetails itemId={state.itemId} itemType={state.itemType} itemAction={TaskItemAction.none} onClose={onClose} />
  </Modal >
}

export function CallViewByItemDetails({ itemId, itemType, itemAction, onClose }: { itemId: string, itemType: MediaType, itemAction: TaskItemAction, onClose?(): void }) {
  const [data, setData] = useState<CallHistoryDetailsEntry>()

  useEffect(() => {
    let mounted = true
    load()
    return () => { mounted = false }

    async function load() {
      setData(undefined)
      let d = await getCallHistoryDetails(itemId, itemType, itemAction)
      if (!mounted) { return }

      setData(d)
    }
  }, [itemId, itemType, itemAction])

  function handleClose() {
    if (onClose)
      onClose()
  }

  if (data) {
    return <div className='CallDetailsPanel'>
      <div className='title'>
        <h2>Details</h2>
        {onClose && <Button className='close' onClick={() => handleClose()}>X</Button>}
      </div>
      <div className='cdp-body'>
        {(itemType === 'CALL' || itemType === 'VM') && <div>Call Details : {data.details}</div>}
        <div>Notes : {data.notes}</div>
        {itemType === 'VM' && <div>Callback : {data.releaseType === 'D' ? 'Deleted' : data.releaseType === 'R' ? 'Rescheduled' : 'Completed'}</div>}
      </div>
    </div>
  } else {
    return <div>Loading...</div>
  }
}
